<div class="dl-page">
  <app-empty-state icon="explore_off" title="Page not found">
    That address does not match anything in the hub. It may have been renamed, or
    the link that brought you here may be out of date.

    <a emptyStateActions routerLink="/" class="dl-btn dl-btn--primary">
      <mat-icon>home</mat-icon>
      Back to the dashboard
    </a>
  </app-empty-state>
</div>
